export default {
  // Page-level
  'customize.title': 'Customize & Quote',
  'customize.backToProduct': 'Back to Product',
  'customize.backToProductList': 'Back to product list',
  'customize.loadingProduct': 'Loading product information...',
  'customize.productNotFound': 'Product not found',
  'customize.selectTargetHint': 'Select a customization<br />target from the top-left<br />to get started.',
  'customize.sku': 'SKU',
  'customize.category': 'Category',
  'customize.capacity': 'Capacity',
  'customize.material': 'Material',
  'customize.weight': 'Weight',
  'customize.processCount': '{{count}} processes',
  'customize.orderQuantity': 'Order Quantity',
  'customize.sampleQuantity': 'Sample Quantity',
  'customize.samplePurchase': 'Sample Purchase',
  'customize.unit': 'pcs',
  'customize.addProcessTitle': 'Add a finishing process',
  'customize.addProcessDesc': 'Click a customization option in the left tree menu to add a process here.',
  'customize.processStep': 'Process {{index}}',
  'customize.finalStep': 'Final Step',
  'customize.cancel': 'Cancel',
  'customize.printQuote': 'Print Quotation',
  'customize.previewTitle': 'Quote Preview',
  'customize.calculating': 'Calculating quote amount...',
  'customize.currency': 'Currency',
  'customize.appliedFx': 'Applied FX rate',
  'customize.quantityLabel': 'Quantity: {{count}} pcs',
  'customize.itemTotal': 'Item Total',
  'customize.productSubtotalUsd': 'Product Subtotal (USD)',
  'customize.finishingSubtotalUsd': 'Finishing Subtotal (USD)',
  'customize.totalQuoteAmount': 'Total Quote Amount',
  'customize.close': 'Close',
  'customize.processing': 'Processing...',
  'customize.requestQuote': 'Request Quote',

  // Errors
  'customize.error.loadingProduct': 'Loading product information.',
  'customize.error.loadingFinishing': 'Failed to load finishing quote information. Please try again shortly.',
  'customize.error.finishingMapping': 'Could not verify the quote information for the selected finishing. Please try again shortly.',
  'customize.error.preview': 'An error occurred while requesting the quote preview.',
  'customize.error.create': 'An error occurred while creating the quote.',

  // Tree
  'customize.tree.title': 'Customization Options',
  'customize.tree.loginRequired': 'Sign in to use finishing options',
  'customize.tree.partsReplace': 'Replace Parts (CAP & PUMP)',
  'customize.tree.finishingColor': 'Finishing & Color Change',
  'customize.tree.printingAdd': 'Add Finishing Printing',

  // Shared finishing selection labels
  'customize.selectPart': 'Select Part',
  'customize.selectMethod': 'Finishing Method',
  'customize.selectColor': 'Select Color',
  'customize.selected': 'Selected',
  'customize.methodsCount': '{{count}} methods',
  'customize.selectPartFirst': '- Select a part first',
  'customize.selectPartHint': 'Select a part on the left to see<br />available finishing methods.',
  'customize.selectMethodFirst': '- Select a method first',
  'customize.confirmHint': '- Press the confirm button',
  'customize.selectMethodHint': 'Select a finishing method in the center<br />to specify a color.',
  'customize.popularColors': 'Popular Colors',
  'customize.premium': 'Premium',
  'customize.customInput': 'Custom',
  'customize.changeColor': 'Change Color',
  'customize.changeColorHint': 'You can change the color or select a different finishing method.',
  'customize.reselect': 'Reselect',
  'customize.confirm': 'Confirm',
  'customize.resetAll': 'Reset All',
  'customize.pantoneCode': 'Pantone Code',
  'customize.noPantone': 'Pantone not specified',
  'customize.selectThisColor': 'Select This Color',
  'customize.selectColorButton': 'Select This Color',
  'customize.done': 'Done',
  'customize.edit': 'Edit',
  'customize.removeProcess': 'Remove this process',
  'customize.confirmedMessage': 'Your selection has been confirmed with the details below.',
  'customize.selectedConditions': 'Selected ({{count}}):',
  'customize.metallic': 'Metallic',
  'customize.pearl': 'Pearl',
  'customize.softTouch': 'Soft Touch',
  'customize.pantoneRequired': 'Please enter a Pantone code.',
  'customize.hexInvalid': 'Please enter a valid HEX color code. (e.g. #FF6B6B)',
  'customize.customColorHint': 'Enter the desired Pantone number and color directly.',
  'customize.keepExistingColor': 'Keep existing color',
  'customize.colorPlaceholder': 'e.g. Pantone 185 C',

  // Shared AI progress / result
  'customize.progressLabel': 'Progress (estimated 1 min – 1 min 30 sec)',
  'customize.aiGeneratedImage': 'AI Generated Image',
  'customize.generatedCheck': 'Check the generated image',
  'customize.imageLoadError': 'Could not load the image',
  'customize.regenerate': 'Generate Again',
  'customize.viewLarge': 'View Larger',
  'customize.download': 'Download',
  'customize.aiGenerateAgain': 'Generate Again',
  'customize.generateFailed': 'Generation Failed',
  'customize.retry': 'Try Again',
  'customize.aiImageInfo': 'About AI Generated Images',
  'customize.aiImageInfo1': 'This image is a reference preview created using AI technology to help you understand how your design and finishing will be applied.',
  'customize.aiImageInfo2': 'The shape, size, color, material, transparency, gloss, print position, print area, and finishing effects of AI-generated images may differ from the actual product.',
  'customize.aiImageInfo3': 'Actual production proceeds after confirming the container drawing, printable area, original design files, color standards, finishing method, and production conditions, and only after your final design approval.',

  // Parts replace
  'customize.parts.selectPart': 'Select a part to replace',
  'customize.parts.selectHint': 'Shown when<br />selected',
  'customize.parts.loading': 'Loading compatible parts...',
  'customize.parts.empty': 'No parts match the conditions',
  'customize.parts.aiPreview': 'AI Part Assembly Preview',
  'customize.parts.aiUnavailable': 'AI Processing Unavailable',
  'customize.parts.confirmBeforeStart': 'Please check before starting',
  'customize.parts.currentlyUnavailable': 'Currently unavailable',
  'customize.parts.aiNotice': 'This task is processed using AI. Depending on your internet speed, it may take 1 to 5 minutes.',
  'customize.parts.resourceNotice': 'Sorry, we do not have enough resources for AI processing right now.',
  'customize.parts.start': 'Start',
  'customize.parts.confirm': 'OK',
  'customize.parts.resultCount': '{{count}} results generated',
  'customize.parts.failed': '(failed)',
  'customize.parts.assemblyResult': 'Assembly Result',

  // Finishing
  'customize.finishing.selectDesc': 'Select in order: part → finishing method → color. You can specify each part differently.',
  'customize.finishingOnly.selectDesc': 'Select in order: part → finishing method. Existing colors are kept. You can specify each part differently.',
  'customize.finishing.aiGenerate': 'Generate AI Finishing',
  'customize.finishing.aiPreview': 'AI Finishing Preview',
  'customize.finishing.aiPreviewComplete': 'AI Preview Complete',
  'customize.finishing.workingImage': 'Working Base Image',
  'customize.finishing.aiResult': 'AI Generated Result',
  'customize.finishing.resultTitle': 'AI Finishing Result',

  // Color only
  'customize.color.selectHint': 'Select a color to change. You can choose from popular colors, Premium, or enter it directly.',

  // Printing
  'customize.print.position': 'Print Position',
  'customize.print.positionPlaceholder': 'Select a print position',
  'customize.print.method': 'Select Print Method',
  'customize.print.methodPlaceholder': 'Select a print method',
  'customize.print.autoSet': 'Auto',
  'customize.print.photoTransfer': 'Photo Transfer',
  'customize.print.uploadDesign': 'Upload design file',
  'customize.print.removeFile': 'Remove file',
  'customize.print.upload': 'Upload',
  'customize.print.allowedFormat': 'Allowed formats: JPG, PNG, WebP',
  'customize.print.maxSize': 'Max 10MB / min 300px per side / long edge up to 2,048px',
  'customize.print.ratio': 'Ratio 1:2.5 – 2.5:1',
  'customize.print.aiPreview': 'AI Image Preview',
  'customize.print.noDesignFile': 'No design file',
  'customize.print.positionUnset': 'Position not set',
  'customize.print.uploadingArtwork': 'Uploading artwork...',
  'customize.print.creatingJob': 'Creating printing preview job...',
  'customize.print.uploadFailed': 'File upload failed: {{message}}',
  'customize.print.noWorkingImage': 'No container working image found. Please check the product image first.',
  'customize.print.generateFailed': 'Failed to generate the printing preview.',
  'customize.print.statusError': 'An error occurred while checking status',
  'customize.print.unknownError': 'An unknown error occurred.',
  'customize.print.invalidFile': 'The file could not be used due to an unknown error.',
  'customize.print.capTopTitle': 'CAP Top Printing Notice',
  'customize.print.capTopSubtitle': 'Things to note when uploading an image',
  'customize.print.capTopBody': 'When printing on the CAP top, you must upload a separate image that shows the top of the CAP facing forward.',
  'customize.print.capTopHint': 'Please prepare a separate image of the CAP top (top view) taken straight on, not a side view of the container. A side image alone cannot accurately confirm the top print area.',
  'customize.print.understood': 'I understand',
  'customize.print.uploadedFileAlt': 'Uploaded design file',
  'customize.printing.resultTitle': 'AI Printing Preview Result',

  // Printing positions
  'customize.printPosition.bodyFront': 'Body Front',
  'customize.printPosition.middleRing': 'Middle Ring',
  'customize.printPosition.capSide': 'CAP Side',
  'customize.printPosition.capTop': 'CAP Top',
};